import { Link } from 'react-router-dom';

export default function SEOSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="mb-8">
          <span className="inline-block w-14 h-14 rounded-2xl bg-accent-100 mb-6 flex items-center justify-center">
            <i className="ri-file-list-3-line text-accent-600 text-xl"></i>
          </span>
        </div>

        <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-4">
          O que é Hoobuy Sheet?
        </p>

        <article className="prose-custom">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6 leading-snug">
            A Maneira Mais Inteligente de Comprar Produtos da China
          </h2>

          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-5">
            <p>
              O <strong className="text-foreground-900">Hoobuy Spreadsheet</strong> é uma lista meticulosamente
              organizada com os melhores produtos encontrados nas principais plataformas de compras chinesas,
              como Taobao, 1688 e Weidian. Diferente de outros sites que oferecem listas desatualizadas e sem
              curadoria, o <strong className="text-foreground-900">Hoobuy Sheet</strong> é atualizado constantemente
              por uma comunidade ativa de compradores experientes que testam e verificam cada produto antes de
              adicioná-lo à lista.
            </p>

            <p>
              Com o <strong className="text-foreground-900">Hoobuy Spreadsheet 2025</strong>, você tem acesso
              direto aos produtos mais desejados do momento: desde sneakers raros e edições limitadas de tênis
              como Nike Dunk e Jordan, até peças de streetwear de marcas como Supreme, Essentials e Fear of God.
              Cada item na planilha inclui o link direto para compra, avaliações de qualidade, fotos reais dos
              produtos e informações detalhadas sobre preços e opções de envio.
            </p>

            <p>
              Uma das maiores vantagens de utilizar o <strong className="text-foreground-900">Hoobuy Sheet</strong> é
              a segurança nas transações. Todos os vendedores listados passam por um rigoroso processo de verificação,
              garantindo que você receba exatamente o que comprou. Além disso, a planilha ensina como utilizar agentes
              de compra confiáveis que atuam como intermediários, protegendo seu dinheiro e assegurando a qualidade
              dos produtos antes do envio internacional.
            </p>

            <p>
              Seja você um iniciante no mundo das compras internacionais ou um comprador experiente, o
              <strong className="text-foreground-900"> Hoobuy Spreadsheet</strong> oferece uma experiência completa
              e descomplicada. A planilha está organizada por categorias intuitivas — Shoes, Hoodies, T-Shirts,
              Jackets, Accessories e muito mais — permitindo que você encontre rapidamente os produtos que procura.
              Comece agora sua jornada de compras inteligentes e descubra por que milhares de compradores em todo
              o mundo confiam no Hoobuy Sheet como sua principal fonte de finds da China.
            </p>
          </div>
        </article>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Acessar Hoobuy Sheet
          </a>
          <Link
            to="/artigo/hoobuy-sheet-guia-completo-2025"
            className="px-8 py-3 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Ler Guia Completo
          </Link>
        </div>
      </div>
    </section>
  );
}